import React from 'react';
import { ReactComponent as LogoSvg } from '../assets/logo.svg';

const SIZES = {
  sm: {
    icon: 'h-8 w-8',
    text: 'text-lg',
    textContainer: 'h-8',
    textOffset: 1
  },
  md: {
    icon: 'h-9 w-9',
    text: 'text-xl',
    textContainer: 'h-9',
    textOffset: 1.5
  },
  lg: {
    icon: 'h-10 w-10',
    text: 'text-2xl',
    textContainer: 'h-10',
    textOffset: 2
  }
};

const BrandMark = ({ showText = true, size = 'md', className = '' }) => {
  const sizeConfig = SIZES[size] || SIZES.md;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div
        className={`${sizeConfig.icon} flex-shrink-0 rounded-full`}
        style={{ backgroundColor: 'hsl(var(--background))' }}
      >
        <LogoSvg
          className="h-full w-full text-foreground"
          style={{ color: 'hsl(var(--foreground))', fill: 'currentColor' }}
          aria-hidden
        />
      </div>
      {showText && (
        <div
          className={`flex items-center ${sizeConfig.textContainer} leading-none ${sizeConfig.text}`}
          style={{
            fontFamily: 'var(--font-brand)',
            letterSpacing: '-0.01em',
            transform: `translateY(${sizeConfig.textOffset}px)`
          }}
        >
          <span className="text-[1.30em]">P</span>
          <span>anel</span>
          <span className="text-[1.30em]">G</span>
          <span>ear</span>
        </div>
      )}
    </div>
  );
};

export default BrandMark;
